import React, { useState, useEffect, useImperativeHandle } from 'react';

import AppRouter from './app-router';
import AuthRouter from './auth-router';

import { getAuth } from 'firebase/auth';
import { useSelector, useDispatch} from 'react-redux';

// redux slices
import { selectUser, reset, LoginUser, authorize, resetUser} from '../redux/slices/user'

const RootRouter = () => {

    const auth = getAuth();
    const dispatch = useDispatch();

    const userSlice = useSelector(selectUser)

    // check for logged authorized user
    useEffect(() => {
        // called when auth state changed
        const subscriber = auth.onAuthStateChanged((user) => {
            if(user){
                dispatch(authorize(user))
            }
            else{ 
                dispatch(reset())
            }
        });

        return subscriber;

    }, []);

    return (
        <>
        {
            userSlice != null ?
            <AuthRouter />
            :
            <AppRouter />
        }
        </>
    )
}

export default RootRouter;